<button
  mat-button
  [matMenuTriggerFor]="languageMenu"
  class="language-selector-button"
>
  <app-elearnio-language-span
    [countryCode]="currentLanguage()"
    [showCountryCode]="false"
  >
  </app-elearnio-language-span>
  <mat-icon class="size-s dropdown-icon">expand_more</mat-icon>
</button>

<mat-menu #languageMenu="matMenu" class="language-selector-menu-panel">
  @for (lang of languages; track lang) {
    <button
      mat-menu-item
      (click)="onLanguageChange(lang)"
      [disabled]="lang === currentLanguage()"
      class="language-menu-item"
    >
      <app-elearnio-language-span [countryCode]="lang" [showCountryCode]="true">
      </app-elearnio-language-span>
    </button>
  }
</mat-menu>
